"use strict";
exports.__esModule = true;
function prepareSortVal(n, direction) {
    var a = typeof n.value !== 'undefined' ? n.value : n;
    // Make N/A always at the bottom.
    if (a === 'N/A') {
        if (direction === 'asc') {
            return Number.MAX_SAFE_INTEGER;
        }
        else if (direction === 'desc') {
            return Number.MIN_SAFE_INTEGER;
        }
        else {
            return NaN;
        }
    }
    return a;
}
function sortingAlgorithm(x, y, rowA, rowB, direction) {
    var a = prepareSortVal(x, direction);
    var b = prepareSortVal(y, direction);
    if (isNaN(a) || isNaN(b)) {
        return a === b ? 0 : a < b ? -1 : 1;
    }
    else {
        return parseFloat(a) - parseFloat(b);
    }
}
var YEAR_UNITS = {
    'calendar year': true,
    'year': true
};
function isYearColumn(header) {
    if (header.unit) {
        var unit = header.unit.toLowerCase();
        return YEAR_UNITS[unit];
    }
    return false;
}
function isCategoryColumn(header) {
    return header.lookup === 'Categories';
}
function isDatabaseDropdown(header) {
    return header.type === 'DATABASE_DROPDOWN';
}
function getValueCellTemplate(header, fractionSize) {
    var a = isYearColumn(header) || isCategoryColumn(header) || isDatabaseDropdown(header) ?
        '{{COL_FIELD.value}}' : "{{COL_FIELD.value | numberToFixed: " + fractionSize + "}}";
    var b = '  <span ng-if="COL_FIELD.inherited">{{" (Inherited from " + COL_FIELD.inheritedFrom + ")"}}</span>' +
        '  <span ng-if="COL_FIELD.min || COL_FIELD.max">' +
        '(Min: {{COL_FIELD.min}}; Max: {{COL_FIELD.max}})</span>';
    return a + b;
}
function generateTooltip(header, rowEntity, field) {
    var tooltip = '';
    if (header.template) {
        tooltip += "Display Name: " + header.template[rowEntity.template] + " \n";
    }
    if (rowEntity[field].message) {
        tooltip += rowEntity[field].message;
    }
    return tooltip ? tooltip : null;
}
function getColDefinitionNoGroup(headerMap, fractionSize) {
    return headerMap.map(function (header) {
        return {
            enableHiding: false,
            name: header.display,
            displayName: header.display,
            field: header.key,
            sortingAlgorithm: sortingAlgorithm,
            pinnedLeft: header.isRowHeader,
            width: header.isRowHeader ? 200 : 100,
            cellTooltip: function (row) { return generateTooltip(header, row.entity, header.key); },
            cellTemplate: header.isRowHeader ?
                '<div class="ui-grid-cell-contents pull-left" title="TOOLTIP">' +
                    '<i class="fa fa-lock" ng-if="row.entity.readonly" style="margin-right: 3px"></i>' +
                    '<b>{{COL_FIELD.value || COL_FIELD CUSTOM_FILTERS}}</b>' +
                    '</div>' :
                '<div class="ui-grid-cell-contents" title="TOOLTIP"' +
                    '     ng-style="COL_FIELD.style">' +
                    getValueCellTemplate(header, fractionSize) +
                    '</div>'
        };
    });
}
function getColDefinitionWithGroup(headerMap, fractionSize) {
    return headerMap.map(function (header) {
        return {
            // visible: index > startIndex,
            enableHiding: false,
            groupingShowAggregationMenu: false,
            groupingShowGroupingMenu: false,
            name: header.display,
            displayName: header.display,
            field: header.key,
            sortingAlgorithm: sortingAlgorithm,
            pinnedLeft: header.isRowHeader,
            width: header.isRowHeader ? 150 : 100,
            grouping: header.groupPriority ? { groupPriority: header.groupPriority - 1 } : undefined,
            cellTooltip: function (row) { return generateTooltip(header, row.entity, header.key); },
            cellTemplate: header.isRowHeader ?
                '<div>' +
                    '<div ng-if="!col.grouping || col.grouping.groupPriority === undefined || col.grouping.groupPriority === null || ( row.groupHeader && col.grouping.groupPriority === row.treeLevel )" ' +
                    '    class="ui-grid-cell-contents pull-left" title="TOOLTIP">' +
                    '<i class="fa fa-lock" ng-if="row.entity.readonly" style="margin-right: 3px"></i>' +
                    '<b>{{COL_FIELD.value || COL_FIELD CUSTOM_FILTERS}}</b>' +
                    '</div>' +
                    '</div>' :
                '<div class="ui-grid-cell-contents" title="TOOLTIP"' +
                    '     ng-style="COL_FIELD.style">' +
                    getValueCellTemplate(header, fractionSize) +
                    '</div>'
        };
    });
}
function generateGridOptions(_a, fractionSize, timestamp) {
    var grouped = _a.grouped, headerMap = _a.headerMap, rows = _a.rows;
    var colDef = grouped ?
        getColDefinitionWithGroup(headerMap, fractionSize) :
        getColDefinitionNoGroup(headerMap, fractionSize);
    var gridOptions = {
        enableColumnResizing: true,
        columnDefs: colDef,
        rowTemplate: '<div ng-style="{\'color\': row.entity.color }">' +
            '  <div ng-if="row.entity.merge">{{row.entity.title}}</div>' +
            '  <div ng-if="!row.entity.merge" ' +
            '       ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" ' +
            '       class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell>' +
            '  </div>' +
            '</div>',
        data: rows,
        showGridFooter: true,
        gridFooterTemplate: '<div class="ui-grid-bottom-panel" style="text-align: right; color: #939294; font-size: 10px">' +
            timestamp + '</div>'
    };
    return [gridOptions, grouped];
}
exports.generateGridOptions = generateGridOptions;
function formatCell(val, decimalPoint) {
    if (typeof val === 'undefined' || val === null) {
        return '""';
    }
    var str = val.toString().trim();
    if (!isNaN(val)) {
        return str.replace('.', decimalPoint);
    }
    return "\"" + str + "\"";
}
function generateCsv(_a, csvFormat) {
    var headerMap = _a.headerMap, rows = _a.rows;
    if (!headerMap) {
        return '';
    }
    var cellSeparator = csvFormat === 'EU' ? ';' : ',';
    var decimalPoint = csvFormat === 'EU' ? ',' : '.';
    var headerLine = headerMap.map(function (header) { return formatCell(header['display'], decimalPoint); }).join(cellSeparator);
    var contentLines = rows.map(function (row) {
        return headerMap.map(function (col) {
            var cell = row[col.key];
            var val = typeof cell.value !== 'undefined' ? cell.value : cell;
            return formatCell(val, decimalPoint);
        }).join(cellSeparator);
    });
    contentLines.unshift(headerLine);
    return contentLines.join('\n');
}
exports.generateCsv = generateCsv;
//# sourceMappingURL=universal-table.grid.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/universal-io/app/universal-table2/universal-table.grid.js